import { styled, Snackbar } from '@mui/material';

const StyledSnackbar = styled(Snackbar)(({ theme }) => ({
  '& .MuiSnackbarContent-root': {
    [theme.breakpoints.up('sm')]: {
      flexGrow: 1,
    },
    backgroundColor: 'white',
    padding: 0,
    '& .MuiSnackbarContent-message': {
      padding: 0,
      width: '100%',
    },
    '& .MuiAlert-root': {
      alignItems: 'center',
      padding: '8px 16px',

      '& .MuiAlert-icon': {
        height: 32,
        padding: '5px 0',
      },

      '& .MuiAlert-message': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 8,

        '& .MuiTypography-root': {
          fontSize: 14,
          lineHeight: '20px',
        },
      },
    },
  },
}));

export default StyledSnackbar;
